import { __decorate, __metadata } from 'tslib';
import { $logger } from '../../controllers/logger/logger.js';
import { Service } from '../../decorators/class/service.js';
import { generateRandomId } from '../../utils/string-utils.js';

const DEFAULT_ROOT_GRID = 'root';
const DEFAULT_FLOAT_GRID = 'float';
function newGridId() {
    return `grid-${generateRandomId()}`;
}
let GridService = class GridService {
    constructor() {
        this.grids = new Map();
    }
    initializeDefaultGrid() {
        this.grids.set(DEFAULT_ROOT_GRID, {
            id: DEFAULT_ROOT_GRID,
            current: null,
        });
        this.grids.set(DEFAULT_FLOAT_GRID, {
            id: DEFAULT_FLOAT_GRID,
            current: null,
            type: 'float',
            grids: [],
        });
    }
    /**
     * 获取 Grid 信息
     *
     * @param gridId - grid Id
     */
    getGrid(gridId) {
        var _a;
        return (_a = this.grids.get(gridId)) !== null && _a !== void 0 ? _a : undefined;
    }
    hasGrid(gridId) {
        return this.grids.has(gridId);
    }
    addToFloatGrid(surfaceConfig, isNewFloat = false) {
        if (isNewFloat) {
            const targetGrid = this.newGridInfo(surfaceConfig);
            targetGrid.type = 'float';
            this.addSurfaceToGrid(targetGrid, surfaceConfig);
        }
        else {
            const targetGrid = this.getGrid(DEFAULT_FLOAT_GRID);
            if (targetGrid) {
                this.addSurfaceToGrid(targetGrid, surfaceConfig);
            }
        }
    }
    addToGrid(gridId, surfaceConfig, gridType) {
        var _a, _b, _c, _d;
        const targetGrid = this.grids.get(gridId);
        if (!targetGrid) {
            $logger.error(`Target grid ${gridId} does not exist.`);
            return;
        }
        const hasGrid = ((_b = (_a = targetGrid.grids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        if (!hasGrid && !gridType) {
            this.addSurfaceToGrid(targetGrid, surfaceConfig);
            targetGrid.type = gridType;
            return;
        }
        if (gridType !== targetGrid.type) {
            targetGrid.grids = [];
            // split original targetGrid to two new grid
            // make original grid become the new grids' parent
            if (((_c = targetGrid.surfaces) === null || _c === void 0 ? void 0 : _c.length) || ((_d = targetGrid.grids) === null || _d === void 0 ? void 0 : _d.length)) {
                const newTargetGrid = Object.assign(Object.assign({}, targetGrid), { id: newGridId() });
                newTargetGrid.surfaces = targetGrid.surfaces;
                newTargetGrid.grids = targetGrid.grids;
                this.grids.set(newTargetGrid.id, newTargetGrid);
                this.addGridToTargetGrid(targetGrid, newTargetGrid);
            }
            const newGrid = this.newGridInfo(surfaceConfig);
            this.grids.set(newGrid.id, newGrid);
            this.addGridToTargetGrid(targetGrid, newGrid);
            targetGrid.type = gridType;
            return;
        }
        if (gridType === targetGrid.type) {
            if (hasGrid) {
                const newGrid = this.newGridInfo(surfaceConfig);
                this.addGridToTargetGrid(targetGrid, newGrid);
            }
            else {
                this.addSurfaceToGrid(targetGrid, surfaceConfig);
            }
        }
    }
    deleteGrid(gridId) {
        var _a, _b;
        const targetGrid = this.grids.get(gridId);
        if (!targetGrid) {
            $logger.error(`Target grid ${gridId} does not exist.`);
            return;
        }
        if (gridId === DEFAULT_FLOAT_GRID || gridId === DEFAULT_ROOT_GRID) {
            return;
        }
        if (targetGrid.parent) {
            const parentGrid = this.grids.get(targetGrid.parent);
            const index = (_a = parentGrid === null || parentGrid === void 0 ? void 0 : parentGrid.grids) === null || _a === void 0 ? void 0 : _a.indexOf(gridId);
            if (index && index !== -1) {
                (_b = parentGrid === null || parentGrid === void 0 ? void 0 : parentGrid.grids) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
            }
        }
        this.grids.delete(gridId);
    }
    addGridToTargetGrid(targetGrid, grid) {
        var _a;
        (_a = targetGrid.grids) === null || _a === void 0 ? void 0 : _a.push(grid.id);
        grid.parent = targetGrid.id;
        if (targetGrid.type === 'stack') {
            targetGrid.stackCurrent = grid.id;
        }
    }
    addSurfaceToGrid(grid, surfaceConfig) {
        var _a;
        const targetGrid = grid;
        targetGrid.surfaces = [...(_a = targetGrid === null || targetGrid === void 0 ? void 0 : targetGrid.surfaces) !== null && _a !== void 0 ? _a : [], surfaceConfig.id];
        surfaceConfig.grid = grid.id;
        targetGrid.current = surfaceConfig.id;
    }
    newGridInfo(surfaceConfig) {
        const grid = {
            id: newGridId(),
            current: null,
        };
        if (surfaceConfig) {
            this.addSurfaceToGrid(grid, surfaceConfig);
        }
        this.grids.set(grid.id, grid);
        return grid;
    }
};
GridService = __decorate([
    Service(),
    __metadata("design:paramtypes", [])
], GridService);

export { DEFAULT_FLOAT_GRID, DEFAULT_ROOT_GRID, GridService };
//# sourceMappingURL=grid-service.js.map
